import React from "react";
import { useTranslation } from "react-i18next";
import aerial from "../../Assets/ServiceImg/aerial.webp"; // Imagen específica del servicio
import aerialmenubg from "../../Assets/ServiceImg/aerial-bg.webp"; // Imagen de fondo de las preguntas
import aerialquestionsbg from "../../Assets/ServiceImg/aerial-qbg.webp"; // Imagen de fondo de las preguntas
import Contact from "../Home/Contact";
import ServiceInfo from "./ServiceInfo";
import Card from "react-bootstrap/Card";
import { Helmet } from "react-helmet-async";
import Seoimg from "../../Assets/ServiceImg/aerial-bg.webp";
import { useLocation } from "react-router-dom";

const AerialPhotography = () => {
   const { t } = useTranslation();

   const location = useLocation();
   const selectedLanguage = location.pathname.startsWith("/en") ? "en" : "es";

   const seoTranslations = {
      es: {
         title: "Servicios de Fotografía y Vídeo Aéreo con Drones | Joan Company",
         description:
            "Ofrezco servicios profesionales de fotografía y vídeo aéreo con drones para inmobiliarias, eventos y proyectos técnicos.",
         keywords:
            "fotografía aérea, videografía aérea, servicios con drones, grabación con drones, filmación con drones, fotografía inmobiliaria con drones, eventos con drones, inspecciones técnicas con drones",
         canonical: "https://www.joancompany.es/fotografia-aerea",
      },
      en: {
         title: "Aerial Photography and Video Services with Drones | Joan Company",
         description:
            "I offer professional aerial photography and video services with drones for real estate, weddings, events and technical projects.",
         keywords:
            "aerial photography, aerial videography, drone services, drone recording, drone filming, real estate photography with drones, events with drones, technical inspections with drones",
         canonical: "https://www.joancompany.es/en/fotografia-aerea",
      },
   };

    return (
       <div className="service-container">
          <Helmet>
             <title key="title">
                  {seoTranslations[selectedLanguage].title}
             </title>
             <meta
                key="description"
                name="description"
                content={seoTranslations[selectedLanguage].description}
             />
             <meta
                key="keywords"
                name="keywords"
                content={seoTranslations[selectedLanguage].keywords}
             />
             <link
                rel="canonical"
                href={seoTranslations[selectedLanguage].canonical}
             />
             <meta property="og:image" content={Seoimg} />
             <meta
                property="og:title"
                content={seoTranslations[selectedLanguage].title}
             />
             <meta
                property="og:description"
                content={seoTranslations[selectedLanguage].description}
             />
             <link rel="image_src" href={Seoimg} />
             <link
                rel="alternate"
                href="https://www.joancompany.es/fotografia-aerea"
                hreflang="es"
             />
             <link
                rel="alternate"
                href="https://www.joancompany.es/en/fotografia-aerea"
                hreflang="en"
             />
               <html lang={selectedLanguage} />
          </Helmet>
          <ServiceInfo
             title={t("aerial_photography")}
             image={aerialmenubg}
             subtitle={t("aerial_photography_desc")}
             description={t("aerial_photography_desc")}
          />
          <Card
             className="quote-card-view"
             id="service-info-card"
            //  data-aos="fade-in"
            //  data-aos-duration="1000"
          >
             <Card.Body>
                <div className="service-info-content-container">
                   <div className="service-info-content">
                      <h3>{t("aerial_photography_subtitle")}</h3>
                      <div
                         dangerouslySetInnerHTML={{
                            __html: t("aerial_photography_info"),
                         }}
                      />
                   </div>
                   <div className="service-info-image">
                      <img
                         src={aerial}
                         alt={t("aerial_photography")}
                         title={t("aerial_photography")}
                         loading="lazy"
                      />
                   </div>
                </div>
             </Card.Body>
          </Card>
          <div
             className="service-questions"
             style={{ backgroundImage: `url(${aerialquestionsbg})` }}
          >
             <div className="service-questions-container">
                <div
                   dangerouslySetInnerHTML={{
                      __html: t("aerial_photography_questions"),
                   }}
                />
             </div>
          </div>
          <Contact />
       </div>
    );
};

export default AerialPhotography;
